export default __webpack_public_path__ + "static/media/yummy-menu-desktop.e1b99c71.jpg";